import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import imgp1 from "../asset/image/imgp1.jpg";
import img2 from "../asset/image/img2.jpg";
import img3 from "../asset/image/img3.jpg";
import img4 from "../asset/image/img4.jpg";
import imgp5 from "../asset/image/imgp5.jpg";
import img6 from "../asset/image/img6.jpg";
import img7 from "../asset/image/img7.jpg";
import img8 from "../asset/image/img8.jpg";
import img9 from "../asset/image/img9.jpg";
import img10 from "../asset/image/img10.jpg";
import img11 from "../asset/image/img11.jpg";
import img12 from "../asset/image/img12.jpg";
import img13 from "../asset/image/img13.jpg";
import img14 from "../asset/image/img14.jpg";
import img15 from "../asset/image/img15.jpg";
import img16 from "../asset/image/img16.jpg";
import img17 from "../asset/image/img17.jpg";
import img18 from "../asset/image/img18.jpg";
import img19 from "../asset/image/img19.jpg";
import img20 from "../asset/image/img20.jpg";
import "./Packages.css";

// CHAMINDU : Fixed spellings in titles.
const packages = [
  {
    id: 1,
    title: "1 day Package",
    description: "Discover the ancient marvel of Sigiriya...",
    image: imgp1,
    pax: 3,
    days: 1,
    route: "/pk1",
  },
  {
    id: 3,
    title: "3 day Package",
    description: "Explore the largest cave temple complex...",
    image: img3,
    pax: 4,
    days: 3,
    route: "/pk3",
  },
  {
    id: 4,
    title: "4 day Package",
    description: "Embark on a wildlife safari...",
    image: img4,
    pax: 2,
    days: 4,
    route: "/pk4",
  },
  {
    id: 5,
    title: "5 day Package",
    description: "Marvel at this iconic railway bridge...",
    image: imgp5,
    pax: 3,
    days: 5,
    route: "/pk5",
  },
  {
    id: 6,
    title: "6 day Package",
    description:
      "Trek through this UNESCO site and witness the dramatic cliff edge of World’s End and serene Baker’s Falls.",
    image: img6,
    pax: 2,
    days: 6,
    route: "/pk6",
  },
  {
    id: 7,
    title: "7 day Package",
    description:
      "Scale this sacred mountain, cherished by multiple religions, and catch an unforgettable sunrise.",
    image: img7,
    pax: 2,
    days: 7,
    route: "/pk7",
  },
  {
    id: 10,
    title: "10 day Package",
    description:
      "Admire the cascading waters of Ravana Falls, a scenic spot steeped in local folklore.",
    image: img10,
    pax: 2,
    days: 10,
    route: "/pk10",
  },
];
// Add similar cards for 3, 4, and 10 days packages

const Packages = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState("all"); // State to store filter: '3', '4', '10', or 'all'
  const [filteredPackages, setFilteredPackages] = useState([]);

  const handleCardClick = (route) => {
    navigate(route);
  };

  const handleFilterClick = (days) => {
    setFilter(days);
  };

  useEffect(() => {
    const p =
      filter === "all"
        ? packages
        : packages.filter((pkg) => pkg.days === parseInt(filter));
    setFilteredPackages(p);
  }, [filter]);

  return (
    <main className="main-content">
      <center>
        <h1 className="filter-heading">Our Tour Packages</h1>
      </center>

      {/* Filter Buttons */}
      <div className="filter-buttons">
        <button onClick={() => handleFilterClick("all")} className="filter-btn">
          All Packages
        </button>
        <button onClick={() => handleFilterClick("5")} className="filter-btn">
          5 Days Packages
        </button>
        <button onClick={() => handleFilterClick("7")} className="filter-btn">
          7 Days Packages
        </button>
        <button onClick={() => handleFilterClick("10")} className="filter-btn">
          10 Days Packages
        </button>
      </div>

      {/* Packages Grid */}
      <div className="packages-container">
        <div className="packages-grid">
          {filteredPackages.map((pkg) => (
            <div
              key={pkg.id}
              className="package-card"
              onClick={() => handleCardClick(pkg.route)}
              style={{ cursor: "pointer" }}
            >
              <img src={pkg.image} alt={pkg.title} className="package-image" />
              <div className="package-content-overlay">
                <div>
                  <h2 className="package-title">{pkg.title}</h2>
                  <p className="package-description">{pkg.description}</p>
                </div>
                <div className="package-footer">
                  <div className="package-stats">
                    {/* <span className="pax-info">{pkg.pax} pax</span> */}
                    <span className="days-info">{pkg.days} days</span>
                  </div>
                  {/* <div className="package-price">
                    <span className="price-amount">${pkg.price}</span>
                  </div> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default Packages;
